export const defaultPopupImg = {
  id: null,
  url: '',
  file: null,
  loading: false,
}

export const defaultPopupInfo = {
  title: '',
  description: '',
  theme: 'light',
}

export const defaultPopupRedirect = {
  buttonName: '',
  buttonColor: '',
  fontColor: '',
  linkType: 'custom',
  linkName: '',
  sportId: '',
  link: [],
  id: '',
  isRedirectAvailable: false,
}

export const POPUP_CONTENT_FORM_FIELDS = {
  popupImage: {
    ...defaultPopupImg,
  },
  popupInfo: {
    ...defaultPopupInfo,
  },
  popupRedirect: {
    ...defaultPopupRedirect,
  },
}
